


































import { Component, Prop, Mixins } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";
import {
  PORTAL_OFFICE_PENDING_JOIN_SERVICE,
  PORTAL_OFFICE_PRIMARY_SERVICE_TYPE,
} from "@/consts/portal";

/**
 * 2サービス目の参加申請（保留）がある事業所を承認するときに、
 * 1サービス目として承認するサービス（primary_service_type）を選ばせるダイアログ
 */
@Component
export default class PortalOfficePrimaryServiceDialog extends Mixins(
  UtilMixin
) {
  /** OKボタンのラベル */
  @Prop({ default: "承認する" }) private okLabel!: string;

  private PORTAL_OFFICE_PRIMARY_SERVICE_TYPE =
    PORTAL_OFFICE_PRIMARY_SERVICE_TYPE;

  /** ダイアログ表示・非表示用フラグ */
  private dialog = false;
  /** 保留中のサービス（1:けあログっと, 2:カエドキ） */
  private pendingJoinService = 0;
  /** 選択したサービス（0:未選択） */
  private selected = 0;
  private resolveFunc: ((value: number) => void) | null = null;

  private get pendingServiceName(): string {
    return this.idToText(
      this.pendingJoinService,
      PORTAL_OFFICE_PENDING_JOIN_SERVICE
    );
  }

  /**
   * ダイアログを開く
   * @returns 選択したサービス（1:けあログっと, 2:カエドキ）。キャンセル時は 0
   */
  public open(pendingJoinService: number): Promise<number> {
    this.pendingJoinService = pendingJoinService;
    this.selected = 0;
    this.dialog = true;
    return new Promise((resolve) => {
      this.resolveFunc = resolve;
    });
  }

  private ok() {
    this.close(this.selected);
  }

  private cancel() {
    this.close(0);
  }

  private close(value: number) {
    this.dialog = false;
    if (this.resolveFunc) {
      this.resolveFunc(value);
      this.resolveFunc = null;
    }
  }
}
